var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"st1","d":"M20.9,2H3.1C2.5,2,2,2.5,2,3.1v17.8C2,21.5,2.5,22,3.1,22h9.6v-7.7h-2.6v-3h2.6V9c0-2.6,1.6-4,3.9-4\n\t\tc1.1,0,2.1,0.1,2.3,0.1v2.7l-1.6,0c-1.3,0-1.5,0.6-1.5,1.5v1.9h3l-0.4,3h-2.6V22h5.1c0.6,0,1.1-0.5,1.1-1.1V3.1\n\t\tC22,2.5,21.5,2,20.9,2z","key":0}),React.createElement("path",{"d":"M0,0h24v24H0V0z","fill":"none","key":1})]);
}

Icon.defaultProps = {"fill":"#3c5a99","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = Icon;

Icon.default = Icon;
